import { useEffect, useRef } from 'react'
import { useVoiceStore } from '../../stores/voiceStore'
import ActivityFeed from './ActivityFeed'

// Live activity feed for the currently joined voice channel. Visible to
// every participant in the call (server gates only the *history* view).
// Owns the scroll container + auto-scroll; ActivityFeed does the layout.
export default function ActivityLogPanel() {
  const events = useVoiceStore((s) => s.sessionActivity)
  const scrollRef = useRef<HTMLDivElement>(null)

  // Pin to bottom on new events (latest at the bottom, like chat).
  useEffect(() => {
    const el = scrollRef.current
    if (el) el.scrollTop = el.scrollHeight
  }, [events.length])

  return (
    <div ref={scrollRef} className="h-full overflow-y-auto">
      <ActivityFeed events={events} stickyHeaders />
    </div>
  )
}
